// mapUtils.js
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import mapboxgl from 'mapbox-gl';
import axios from 'axios';

let mapInstance = null; // ← keep a module‐level reference to the current map

function findCenter(points) {
  if (points.length === 0) {
    throw new Error("No points provided");
  }

  let totalLat = 0;
  let totalLon = 0;

  for (const point of points) {
    totalLat += parseFloat(point['lngLat'][0]);
    totalLon += parseFloat(point['lngLat'][1]);
  }

  const centerLat = totalLat / points.length;
  const centerLon = totalLon / points.length;

  return { latitude: centerLat, longitude: centerLon };
}

const initializeMapWithAccessToken = async (activeMap) => {
  // fetch the access token
  const url = `https://myloportal.com.au/api/technician/mapbox/67c67e2bb077c6b61f8790e4`;
  const data = await axios.get(url);
  mapboxgl.accessToken = data.data.access_token;

  return new Promise((resolve) => {
    const createMap = () => {
      const mapContainer = document.getElementById('map');
      const centerPointVIC = ['145.00775985338845', '-37.88515495465279'];
      const centerPointNSW = ['151.25069536884078', '-33.891354656184305'];
      const centerPoint = activeMap === "VIC" ? centerPointVIC : centerPointNSW;

      if (!mapContainer) {
        // If the container isn't in the DOM yet, try again on the next frame.
        requestAnimationFrame(createMap);
        return;
      }

      // If there's already a Mapbox map attached, remove it:
      if (mapInstance) {
        mapInstance.remove();
        mapInstance = null;
      }

      // Now the container is empty: create a brand‐new map.
      const map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/hikasdasd/clduslmz4000401qsu6p53z6o',
        center: centerPoint,
        zoom: 13
      });

      // store this map instance so we can remove it next time
      mapInstance = map;

      // add a custom marker
      const el = document.createElement('a');
      el.className = 'marker_btn';
      const icon = document.createElement('i');
      icon.className = 'fa-solid fa-location-dot';
      icon.style.fontSize = '35px';
      icon.style.color = "#000000";
      el.appendChild(icon);

      new mapboxgl.Marker(el)
        .setLngLat(centerPoint)
        .addTo(map);

      map.on('load', () => {
        map.addLayer({
          'id': 'add-3d-buildings',
          'source': 'composite',
          'source-layer': 'building',
          'filter': ['==', 'extrude', 'true'],
          'type': 'fill-extrusion',
          'minzoom': 15,
          'paint': {
            'fill-extrusion-color': '#aaa',
            'fill-extrusion-height': [
              'interpolate',
              ['linear'],
              ['zoom'],
              15,
              0,
              15.05,
              ['get', 'height']
            ],
            'fill-extrusion-base': [
              'interpolate',
              ['linear'],
              ['zoom'],
              15,
              0,
              15.05,
              ['get', 'min_height']
            ],
            'fill-extrusion-opacity': 0.6
          }
        });
      });

      resolve(map);
    };

    createMap();
  });
};

export default initializeMapWithAccessToken;
